export default __webpack_public_path__ + "static/media/tobi.6f3f55fb.jpg";